import { createClient } from '@supabase/supabase-js';

// Support both VITE_PUBLIC_ and VITE_ prefixes for compatibility
const supabaseUrl =
  (import.meta.env.VITE_PUBLIC_SUPABASE_URL as string) ||
  (import.meta.env.VITE_SUPABASE_URL as string) ||
  'https://placeholder.supabase.co';

const supabaseAnonKey =
  (import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string) ||
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string) ||
  'placeholder-key';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const isSupabaseConfigured =
  (!!import.meta.env.VITE_PUBLIC_SUPABASE_URL || !!import.meta.env.VITE_SUPABASE_URL) &&
  (!!import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY || !!import.meta.env.VITE_SUPABASE_ANON_KEY);
